import Catalog from "../../../pages-v1/Catalog";

export const Page = Catalog;
